import React, { useRef } from 'react';
var VeltAutocompleteEmpty = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-empty", { ref: ref }, children));
};
export default VeltAutocompleteEmpty;
